import * as MobX from "mobx";

export class HireStatusTypeModel {
    constructor(dto: HireStatusTypeDTO | null = null) {
        if (dto) {
            this.id = dto.id;
            this.ordinal = dto.ordinal;
            this.displayName = dto.displayName;
            this.type = dto.type;
            this.color = dto.color;
            this.textColor = dto.textColor;
        }
    }

    @MobX.observable
    public id: string = "";

    @MobX.observable
    public ordinal: number = 0;

    @MobX.observable
    public displayName: string = "Not defined";

    @MobX.observable
    public type: HireStatusEnum = HireStatusEnum.OnHire;

    @MobX.observable
    public color: string = "#000000";

    @MobX.observable
    public textColor: string = "#FFFFFF";
}

export type HireStatusTypeDTO = {
    id: string;
    ordinal: number;
    displayName: string;
    type: HireStatusEnum;
    color: string;
    textColor: string;
};

export enum HireStatusEnum {
    OnHire = 10,
    OffHired = 20,
    Purchased = 30,
    NA = 40,
}
